const styles = (theme) => ({
  progressBox: {
    width: 30,
    height: 30,
  },
  circularProgress: {
    position: 'absolute',
    top: 3,
    left: 3,
    zIndex: 1,
  },
});

export default styles;
